import { CascoPackage } from '@insurance/api/requests'
import { InputParsedNumber } from '@shared/components'
import { Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps, MAX_BONUS, MIN_BONUS } from './utils'

export const DriverDiscount = () => {
  const { t } = useTranslation()
  const {
    vehicleQuantityProps,
    annualBonusProps,
    claimLastYearProps,
    insurancePackageProps
  } = formProps(t)
  const { isEditable } = useCascoInsuranceValues()
  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })
  const claimLastYear = Form.useWatch(claimLastYearProps.name, {
    preserve: true
  })

  if (insurancePackage === CascoPackage.MINI) return null

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} lg={12}>
        <Form.Item {...annualBonusProps}>
          <InputParsedNumber
            disabled={!!claimLastYear || isEditable}
            placeholder={annualBonusProps.label}
            min={MIN_BONUS}
            max={MAX_BONUS}
            suffix="%"
            className="w-full"
          />
        </Form.Item>
      </Col>

      <Col xs={24} lg={12}>
        <Form.Item {...vehicleQuantityProps}>
          <InputParsedNumber
            placeholder={vehicleQuantityProps.label}
            min={0}
            disabled={isEditable}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
